/* External */
import { memo, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

/* Components */
import SwimlaneCarouselContainer from '../SwimlaneCarousel';
import { useItemData } from '../VirtualizedList';

function CarouselRow({ index }) {
  const {
    carouselsInfo,
    pageId,
    fetchedCarousels,
    handleCarouselFetchComplete,
    stealFocusOnMount,
    firstNonEmptyCarousel,
    updateWasCarouselFocused,
  } = useItemData();
  const carouselInfo = useMemo(() => carouselsInfo.get(index), [index, carouselsInfo]);

  const avoidFetch = useMemo(
    () => fetchedCarousels.has(carouselInfo?.sourceCarouselId || carouselInfo?.elementId),
    [carouselInfo?.sourceCarouselId, carouselInfo?.elementId, fetchedCarousels],
  );

  const handleFetchComplete = useCallback((id, carousel) => {
    handleCarouselFetchComplete(id, carousel, index);
  }, [handleCarouselFetchComplete, index]);

  const carouselVerticalPosition = useMemo(() => index + 1, [index]);

  return (
    <SwimlaneCarouselContainer
      carouselInfo={carouselInfo}
      pageId={pageId}
      avoidFetch={avoidFetch}
      onFetchComplete={handleFetchComplete}
      stealFocusByDefault={stealFocusOnMount && index === firstNonEmptyCarousel}
      onBecameFocused={updateWasCarouselFocused}
      carouselVerticalPosition={carouselVerticalPosition}
    />
  );
}

CarouselRow.propTypes = {
  index: PropTypes.number.isRequired,
};

export default memo(CarouselRow);
